export default {
	save (aModel, aReturnModel) {
		let lModel = typeof aModel === 'undefined' ? this.model : aModel
		let lReturnModel = typeof aModel === 'undefined' ? false : aReturnModel

		return new Promise((resolve, reject) => {
			if (lModel.validateModel()) {
				console.log("!! functions.models.if !!")
				this.$store.dispatch('saveModel', lModel)
				.then(response => {
					console.log("!! functions.models.save.if.resolve !!")
					resolve(lReturnModel ? response : response.id)
				})
				.catch(err => {
					console.log("!! functions.models.save.if.catch !!")
					reject(lReturnModel ? {} : 0)
				})
			} else {
				console.log("!! functions.models.save.else !!")
				reject({})
			}
		})
	},

	remove (aModel) {
		let lModel = typeof aModel === 'undefined' ? this.model : aModel

		return new Promise((resolve, reject) => {
			this.$store.dispatch('deleteModel', lModel)
			.then(response => {
				this.$store.dispatch('loadModel', lModel.name)
				.then(response => resolve(response))
				.catch(response => reject(response))
			})
			.catch(response => {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/functions/models.js